import React from "react";

export const FromBlogs = () => {
  return (
    <>
      <div>
        <img src="https://static.thcdn.com/images/small/webp/widgets/208-us/16/0818_THG0035093_DS_SEPT_SHOT_27_031_%281%29-101016.jpg" />
        <h6>Flower Power: Meet the Family Behind Chantecaille</h6>
      </div>
      <div>
        <img src="https://static.thcdn.com/images/small/webp/widgets/208-us/27/fragrance_blog_%281%29-075627.jpg" />
        <h6>Introducing: The Fragrance Shop</h6>
      </div>
      <div>
        <img src="https://static.thcdn.com/images/small/webp/widgets/208-us/13/Augustinus-Bader_1659128996-848x672-013513.jpg" />
        <h6>
          Introducing Augustinus Bader: Your One Stop Shop for Science-Backed
          Beauty
        </h6>
      </div>
      <div>
        <img src="https://static.thcdn.com/images/small/webp/widgets/208-us/38/skin_timeline_%281%29-051238.jpg" />
        <h6>The Ultimate Skin Care Timeline</h6>
      </div>
    </>
  );
};
